import { BASE_ROLES_NAMES } from '../../../../shared/constants.js';

export function initFreshDeskWidget(user, isPlgTenant = false) {
  const userEmail = user.getEmail();
  const userLanguage = user.getSetting('language') || 'en';
  const userName = user.getDisplayName();

  if (!userEmail) return;

  const ENTERPRISE_WIDGET_UUID = 'cd76bcf6-7341-4372-97c7-37aba1ffcc66';
  const PLG_ADMIN_WIDGET_UUID = 'c34b782e-dda1-4143-bc71-9d0b5d25f2ff';
  const PLG_LEARNER_WIDGET_UUID = '1abc7648-b1c1-47ed-a5ab-ea9f1ab0ebb7';

  const getWidgetUuid = () => {
    if (isPlgTenant) return user.hasRole(BASE_ROLES_NAMES.ADMIN) ? PLG_ADMIN_WIDGET_UUID : PLG_LEARNER_WIDGET_UUID;
    return ENTERPRISE_WIDGET_UUID;
  };

  const chatScript = document.createElement('script');
  // documentation: https://developers.freshchat.com/web-sdk/v1/#web-messenger
  chatScript.innerHTML = `
    function initFreshChat() {
      window.fcWidget.init({
        token: "65da530c-e101-4db2-9282-2c59173aae13",
        host: "https://d2lwave.freshchat.com",
        widgetUuid: "${getWidgetUuid()}",
        locale: "${userLanguage}",
        email: "${userEmail}",
        externalId: "${userName}",
      });
    }
    function initialize(i,t){var e;i.getElementById(t)?
    initFreshChat():((e=i.createElement("script")).id=t,e.async=!0,
    e.src="https://d2lwave.freshchat.com/js/widget.js",e.onload=initFreshChat,i.head.appendChild(e))}
    initialize(document,"Freshchat-js-sdk")
  `;

  document.body.appendChild(chatScript);
}
